import React from 'react';

const currentYear = new Date().getFullYear();

const relIcon = { wife: '👩', husband: '👨', son: '👦', daughter: '👧', other: '👤' };
const relColors = { wife: '#7c3aed', husband: '#2563eb', son: '#0891b2', daughter: '#db2777', other: '#6b7280' };
const communionColors = {
  taking: { bg: '#dcfce7', color: '#15803d', label: 'Taking Communion' },
  not_taking: { bg: '#fef9c3', color: '#a16207', label: 'Not Taking' },
  excommunicated: { bg: '#fee2e2', color: '#b91c1c', label: 'Excommunicated' },
  unknown: { bg: '#f3f4f6', color: '#6b7280', label: 'Unknown' },
};
const lifeStatusColors = {
  active: { bg: '#dcfce7', color: '#15803d', label: 'Active' },
  member: { bg: '#dcfce7', color: '#15803d', label: 'Active Member' },
  inactive: { bg: '#fee2e2', color: '#b91c1c', label: 'Inactive' },
  transferred: { bg: '#dbeafe', color: '#1d4ed8', label: 'Transferred' },
  changed_religion: { bg: '#f3f4f6', color: '#6b7280', label: 'Changed Religion' },
  deceased: { bg: '#1f2937', color: '#fff', label: 'Deceased' },
  suspended: { bg: '#fee2e2', color: '#b91c1c', label: 'Suspended' },
  other: { bg: '#f3f4f6', color: '#6b7280', label: 'Other' },
};

const DependentCard = ({ d, onChangeStatus }) => {
  const age = d.birth_year ? currentYear - parseInt(d.birth_year) : null;
  const communion = communionColors[d.holy_communion] || communionColors.unknown;
  const relColor = relColors[d.relationship] || '#6b7280';
  const icon = relIcon[d.relationship] || '👤';
  const ls = d.life_status || 'active';
  const lifeStatus = lifeStatusColors[ls] || lifeStatusColors.active;
  const dimmed = ls !== 'active' && ls !== 'member';

  return (
    <div style={{
      background: '#fff',
      border: '1px solid #e5e7eb',
      borderRadius: 12,
      overflow: 'hidden',
      flex: '1 1 220px',
      maxWidth: 260,
      boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
      opacity: dimmed ? 0.7 : 1,
    }}>
      <div style={{ height: 4, background: relColor }} />

      <div style={{ padding: '14px 16px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
          <div style={{ width: 36, height: 36, borderRadius: '50%', background: `${relColor}18`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, flexShrink: 0, filter: dimmed ? 'grayscale(0.5)' : 'none' }}>
            {icon}
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: 700, fontSize: 14, color: '#111827', textDecoration: ls === 'deceased' ? 'line-through' : 'none' }}>
              {d.first_name ? `${d.first_name} ${d.middle_name || ''} ${d.last_name || ''}`.trim() : d.name}
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 1 }}>
              <span style={{ fontSize: 11, fontWeight: 600, color: relColor, textTransform: 'capitalize' }}>{d.relationship}</span>
              {d.sub_card_number && (
                <span style={{ fontFamily: 'monospace', fontSize: 10, color: '#4f46e5', fontWeight: 700, background: '#eef2ff', padding: '1px 6px', borderRadius: 4 }}>
                  {d.sub_card_number}
                </span>
              )}
            </div>
          </div>
        </div>

        {(age !== null || d.birth_year) && (
          <div style={{ display: 'flex', gap: 8, marginBottom: 10, flexWrap: 'wrap' }}>
            {age !== null && (
              <div style={{ background: '#f3f4f6', borderRadius: 6, padding: '4px 10px', fontSize: 12, fontWeight: 600, color: '#374151' }}>
                Age {age}
              </div>
            )}
            {d.birth_year && (
              <div style={{ background: '#f3f4f6', borderRadius: 6, padding: '4px 10px', fontSize: 12, color: '#6b7280' }}>
                b. {d.birth_year}
              </div>
            )}
          </div>
        )}

        <div style={{ borderTop: '1px solid #f3f4f6', marginBottom: 10 }} />

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
          <span style={{ fontSize: 12, color: '#6b7280' }}>Status</span>
          {onChangeStatus ? (
            <button
              type="button"
              onClick={() => onChangeStatus(d)}
              title="Change status"
              style={{ background: lifeStatus.bg, color: lifeStatus.color, fontSize: 11, fontWeight: 600, padding: '3px 10px', borderRadius: 20, border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 5 }}
            >
              {lifeStatus.label} <span style={{ fontSize: 9, opacity: 0.7 }}>✎</span>
            </button>
          ) : (
            <span style={{ background: lifeStatus.bg, color: lifeStatus.color, fontSize: 11, fontWeight: 600, padding: '3px 8px', borderRadius: 20 }}>
              {lifeStatus.label}
            </span>
          )}
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
          <span style={{ fontSize: 12, color: '#6b7280' }}>Holy Communion</span>
          <span style={{ background: communion.bg, color: communion.color, fontSize: 11, fontWeight: 600, padding: '3px 8px', borderRadius: 20 }}>
            {communion.label}
          </span>
        </div>

        {d.notes && (
          <div style={{ marginTop: 10, padding: '8px 10px', background: '#f8fafc', borderRadius: 8, fontSize: 12, color: '#374151', fontStyle: 'italic', borderLeft: '3px solid #e5e7eb' }}>
            {d.notes}
          </div>
        )}
      </div>
    </div>
  );
};

export default DependentCard;
